/**
 * Проверяет является ли переданное значение объектом.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является объектом, иначе false.
 * @example
 * ```typescript
 * import { isObject } from '@direct-frontend/stdlib';
 *
 * isObject({ key: 'value' }); // true
 * isObject([1, 2, 3]); // false
 * isObject(null); // false
 * isObject('string'); // false
 * ```
 */
export function isObject(value) {
    return typeof value === 'object' && !Array.isArray(value) && value !== null && !(value instanceof Date);
}
